import { Text } from '@cleartax/wg-library-typography';
import 'pure-react-carousel/dist/react-carousel.es.css';

import { useIsMobile } from '@cleartax/wg-library-hooks';
import {
  ButtonBack,
  ButtonNext,
  CarouselProvider,
  Slide,
  Slider
} from 'pure-react-carousel';
import { useEffect, useState } from 'react';
import StarRating from '../../../../../../../../shared/components/ui-blocks/star-rating/starRating.component';
import { IReview } from '../types';
export const ReviewCarousel = ({ reviews }: { reviews: Array<IReview> }) => {
  const isMobile = useIsMobile();
  const [visibleSlides, setVisibleSlides] = useState(2);
  useEffect(() => {
    if (isMobile) {
      setVisibleSlides(1);
    }
  }, [isMobile]);
  return (
    <CarouselProvider
      naturalSlideWidth={100}
      isPlaying={true}
      naturalSlideHeight={125}
      isIntrinsicHeight={true}
      infinite={true}
      visibleSlides={visibleSlides}
      totalSlides={reviews.length}
    >
      <div className="flex sm:flex-col">
        <div className="z-0 w-10/12 sm:w-full">
          <Slider className="">
            {reviews.length
              ? reviews.map((ele, index) => {
                  return (
                    <Slide key={index} index={index}>
                      <div className=" w-full py-3 px-2">
                        <div className="px-4 shadow-lg h-60 rounded-lg bg-teal-100">
                          <Text
                            className="text-brand-1000"
                            textSize="lg"
                            weight="bold"
                          >
                            {ele.reviewerName}
                          </Text>
                          <div className="flex">
                            <Text
                              className="text-brand-1000"
                              textSize="lg"
                              weight="bold"
                            >
                              {ele.reviewRating}{' '}
                            </Text>
                            <div className="mt-1 ml-1">
                              <StarRating
                                defaultState={Number(ele.reviewRating)}
                                emptyColor={'grey'}
                                fillColor="#fbaa39"
                                height={20}
                                labelText={() => <></>}
                                maxValue={5}
                                onChangeHover={() => {}}
                                onChangeValue={() => {}}
                                width={20}
                                readOnly={true}
                              />
                            </div>
                          </div>
                          <Text
                            className="text-grey-600  line-clamp-6"
                            weight="semibold"
                            mergeClasses="merge"
                          >
                            {ele.reviewText}
                          </Text>
                        </div>
                      </div>
                    </Slide>
                  );
                })
              : null}
          </Slider>
        </div>
        <div className="flex pr-2 sm:w-full sm:mt-2 justify-center">
          <ButtonBack className="">
            <div className="rounded-3xl bg-grey-200 opacity-1/2  shadow-2xl p-4">
              <Text className="icon-arrow-thin-right rotate-180"></Text>
            </div>
          </ButtonBack>
          <ButtonNext className="ml-2">
            <div className="rounded-3xl bg-grey-200 opacity-1/2  shadow-2xl p-4">
              <Text className="icon-arrow-thin-right "></Text>
            </div>
          </ButtonNext>
        </div>
      </div>
    </CarouselProvider>
  );
};
